import React from 'react';
import { useAuth } from '../../context/AuthContext';
import ChatWidget from '../Messages/ChatWidget';
import './TeacherDashboard.css';

const TeacherDashboard = () => {
  const { user, logout } = useAuth();

  return (
    <div className="teacher-dashboard">
      <div className="teacher-dashboard-content">
        <div className="teacher-header">
          <div className="teacher-icon">👨‍🏫</div>
          <h1>Welcome, {user?.name}!</h1>
          <p className="teacher-subtitle">Teacher Dashboard</p>
        </div>

        <div className="teacher-info-card">
          <h2>How It Works</h2>
          <div className="teacher-steps">
            <div className="teacher-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Students will share meeting links with you</h3>
                <p>You'll receive a unique meeting URL from each student</p>
              </div>
            </div>

            <div className="teacher-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Click the link to join their video session</h3>
                <p>Access the meeting directly through the shared link</p>
              </div>
            </div>

            <div className="teacher-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Help them practice and improve</h3>
                <p>Have conversations, correct mistakes, and provide feedback</p>
              </div>
            </div>
          </div>
        </div>

        <div className="teacher-features-card">
          <h2>What You Can Do</h2>
          <div className="teacher-features">
            <div className="feature-item">
              <span className="feature-icon">💬</span>
              <span>Join video conversations with students</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🎥</span>
              <span>Practice real-time language skills</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🌍</span>
              <span>Help students learn your native language</span>
            </div>
          </div>
        </div>

        <div className="teacher-waiting-card">
          <h3>Waiting for meeting invitations</h3>
          <p>
            When students share their meeting links with you, simply click the link to join their video session.
            No additional setup required!
          </p>
        </div>

        <div className="teacher-actions">
          <button className="teacher-logout-button" onClick={logout}>
            Logout
          </button>
        </div>
      </div>

      {/* Chat Widget - Floating in bottom right */}
      <ChatWidget />
    </div>
  );
};

export default TeacherDashboard;
